
export default {
  name: "ExtraMenu",

  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  components: {
    ExtraMenuElement: () => import("./_ExtraMenuElement")
  }
}
